import React, { useState, useEffect, createContext, useContext } from 'react';

export function ReactRepresentable({ rawValue }) {
    return rawValue ?? "no raw value?"
}